<template>
  <div class="bg" :height="fullHeight" :width="fullWidth">
    <spinner v-if="isLoading" />
    <b-container>
     <b-row>
        <b-col
          cols="12"
          md="8"
          offset-md="2"
          lg="6"
          offset-lg="3"
        >
          <b-card
            img-alt="Image"
            img-top
            tag="article"
            class="mb-2 shadow-sm p-2 mb-2 bg-white rounded"
          >
            <b-card-text class="w-100 text-center">
              <b-img :src="logo" fluid alt="Logo Evento" class="mb-3"></b-img>
              <h3>Ups!!!</h3>
              <p class="lead mb-3">{{ this.mensajes[0].valor }}</p>
              <p>{{ this.mensajes[1].valor }}</p>
              <p><b>{{ this.mensajes[2].valor }}</b><br>
              {{ this.mensajes[3].valor }} {{ idLink }}</p>
            </b-card-text>
              <b-button
                type="button"
                variant="danger"
                size="sm"
                block
                @click="returnLobby"
              >
                {{ this.mensajes[4].valor }}
              </b-button>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Spinner from '@/components/Spinner'
import apiGrals from '../api/config.js'
import routerMessages from '../../config/messages/router.json'
import {
  BContainer,
  BRow,
  BCol,
  BCard,
  BCardText,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BImg,
  BAlert
} from 'bootstrap-vue'

export default {
  name: 'Error',
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
    BCardText,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BImg,
    BAlert,
    Spinner
  },
  data () {
    return {
      // Logo
      logo: '',
      isLoading: true,
      fullWidth: document.documentElement.clientWidth,
      fullHeight: document.documentElement.clientHeight,
      curWidth: '',
      curHeight: '',
      idLink: null,
      mensajes: []
    }
  },
  beforeCreate: function () {
    localStorage.setItem('msgRouter', JSON.stringify(routerMessages))
  },
  async created () {
    if (!localStorage.getItem('images')) {
      await apiGrals
        .getImages('all')
        .then(x => {
          localStorage.setItem('images', JSON.stringify(x.data))
          this.setImages()
        })
        .catch(e => {
          console.log('Error')
        })
    } else {
      this.setImages()
    }
    this.idLink = this.$route.params.pathMatch
    console.log(JSON.stringify(this.$route.params))
    // obtener datos de apigrals desde axios
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
    this.isLoading = false
    // Add mensajes from DB
    const mensajesLocales = JSON.parse(localStorage.getItem('mensajes'))
    this.mensajes = mensajesLocales.filter(mens => {
      if (mens.modulo === 'error') {
        return mens
      }
    })
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    validateState (name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    handleResize (event) {
      this.fullWidth = document.documentElement.clientWidth - 2
      this.fullHeight = document.documentElement.clientHeight - 2
      this.curWidth = this.fullWidth + 'px'
      this.curHeight = this.fullHeight + 'px'
    },
    returnLobby () {
      const ruta = '/' + localStorage.getItem('subnet') + '/lobby'
      this.$router.push({ path: ruta })
    },
    // Filter background and buttons
    setImages () {
      // Obtiene la lista de imagenes de localStorages
      const images = JSON.parse(localStorage.getItem('images'))
      // Filtra logotipo del evento
      let image = images.filter(image => image.keyitem === 'logo')
      this.logo = image[0].image
    }
  }
}
</script>

<style scoped>
.bg {
  background-color: #f6f7f8;
  height: 100vh;
  display: flex;
  align-items: center;
}
.fullheight {
  min-height: 100vh;
  overflow: hidden;
}
/*  Pone manita a todas las areas*/
area {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Error.vue